var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getOrderIdentifier)?_c('v-container',{staticClass:"grey lighten-4"},[_c('show-order',{attrs:{"identifier":_vm.getOrderIdentifier}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }